import React, { useState } from 'react';
import classNames from 'classnames';
import dynamic from 'next/dynamic';

import jobContainerClasses from 'components/jobs/container/index.module.css';
import ZpButton from 'components/zpButton';

import ShareCard from '../../shareCard';

import shareCardClasses from '../../shareCard/index.module.css';
import jobCardClasses from './index.module.css';

const Portal = dynamic(() => import('components/Portal'), { ssr: false });

export default function ShareZippiaJobCard() {
  const [openSharePopup, setOpenSharePopup] = useState(false);

  return (
    <div
      className={classNames(
        shareCardClasses['share-card'],
        jobCardClasses.jobCardBucketListItem,
        jobContainerClasses.bucketListItem,
        'bucketListItem jobCard'
      )}
    >
      <div className="d-flex flex-column justify-content-center align-items-center">
        <div className={shareCardClasses['share-card-top']}>
          <span className={shareCardClasses['share-card-background-heart']}>#</span>
          <img
            className={shareCardClasses['share-card-zippia-icon']}
            alt="Zippia"
            src="/assets/img/zippiaClean.png"
          />
        </div>
        <div className={classNames(shareCardClasses['share-card-do-you-like'], 'mb-0')}>
          Do You Like Zippia?
        </div>
        <div className={classNames(shareCardClasses['share-card-help-your-friends'], 'mb-0')}>
          Help your friends <br /> find the job they want.
        </div>
        <ZpButton
          theme="primary"
          className={classNames(shareCardClasses['share-card-button'])}
          onClick={() => setOpenSharePopup(true)}
        >
          Share With A Friend
        </ZpButton>
      </div>
      {openSharePopup && (
        <Portal>
          <ShareCard
            shareUrl="https://www.zippia.com/"
            closeShareCard={() => setOpenSharePopup(false)}
            children={
              <div className={shareCardClasses['share-card-popup']}>
                Help your friends <br /> find the job they want.
              </div>
            }
          />
        </Portal>
      )}
    </div>
  );
}
